import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

document.querySelectorAll('[data-app="form-contact"]').forEach(function (root) {
  const data = JSON.parse(JSON.stringify(root.dataset));
  ReactDOM.render(<App {...data} />, root);
});
